import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import {
    ICheckbox,
    IColumnchooser,
    IColumnHiding,
    IColumns,
    IEditing,
    IExportExcel,
    IGridOptions,
    IScroll,
    ISearchPanel,
    Toolbar,
} from 'app/interfaces';
import { CoalService } from 'app/services/coal.service';
import {
    MostrarExcepcion,
    MostrarSpinner,
    OcultarSpinner,
} from 'app/store/actions/utils.action';
import { AppState, selectOperacionState, selectUtilsState } from 'app/store/app.states';
import { ConfirmDialogComponent } from 'app/utilerias/confirm-dialog/confirm-dialog.component';
import { ExcepcionesComponent } from 'app/utilerias/excepciones/excepciones.component';
import * as XLSX from 'xlsx';
import * as ExcelJS from 'exceljs/dist/exceljs.min.js';
import saveAs from 'file-saver';
import { Observable } from 'rxjs';
import { DialogNuevoClienteComponent } from 'app/utilerias/nuevo-cliente/dialog-nuevo-cliente.component';
import { BehaviorSubject } from 'rxjs';

@Component({
    selector: 'app-cliente',
    templateUrl: './cliente.component.html',
    styleUrls: ['./cliente.component.scss'],
})
export class ClienteComponent implements OnInit {
    private dataReportSubject: BehaviorSubject<any[]> = new BehaviorSubject<
        any[]
    >([]);
    public dataReport$ = this.dataReportSubject.asObservable();
    nueCliente: boolean = false;
    cargaMasivaCliente: boolean = false;
    contadorCargaMasiva: number;
    data: any;
    datosEventCliente: any;
    spinner: boolean = false;
    getStateOperacion: Observable<any>;
    subscribeOperacion: any;
    idOperacion: number;

    // Grid variables
    gridOptions: IGridOptions;
    columns: IColumns[];
    exportExcel: IExportExcel;
    searchPanel: ISearchPanel;
    scroll: IScroll;
    toolbar: Toolbar[];
    columnHiding: IColumnHiding;
    Checkbox: ICheckbox;
    Editing: IEditing;
    Columnchooser: IColumnchooser;
    objetoGridConfiguration: any;
    objetosSelected: any;
    verGrid: boolean = false;
    btnRefrescar: any;
    lstDataReport = [];
    dataReport = [];
    idTipoReporteSel: number = 1;
    ocultarGrid: boolean = false;
    lstClientes: any = [];
    tituloFile;
    arrayBuffer: any;
    descargarExcel = true;
    nombreReporte: string = '';
    datosevent: any;
    idEmpresa: any;
    configured: boolean = null;
    
    constructor(
        private router: Router,
        public dialog: MatDialog,
        private store: Store<AppState>,
        private srvcoal: CoalService,
        private _snackBar: MatSnackBar
    ) {
        this.dataReport$.subscribe((nuevosDatos) => {
            // Hacer algo con los nuevos datos
            this.dataReport = nuevosDatos;
        });
    }

    ngOnInit(): void {
        this.getStateOperacion = this.store.select(selectOperacionState);
        this.store.select(selectUtilsState).subscribe((state: any) => {
            if( state.empresaSeleccionada === undefined ){
                this.configured = false;
              }
              else{
                this.configured = true;
                if (this.idEmpresa !== state.empresaSeleccionada.id) {
                    this.idEmpresa = state.empresaSeleccionada.id;
                    this.GetCliente()
                }
              }
        });
        this.contadorCargaMasiva = 0;
        this.ocultarGrid = false;
    }

    DescargarPlantilla() {

        const workbook = new ExcelJS.Workbook();
        const general = workbook.addWorksheet('PlantillaClientes');
        let columnas = [
            'NombreRazonSocial',
            'RFC',
            'Email',
            'Calle',
            'NumExterior',
            'NumInterior',
            'Colonia',
            'CP',
            'Ciudad',
            'Municipio',
            'Estado',
            'Pais',
            'CfdiUse',
            'NumRegIdTrib',
            'TaxResidence',
            'Agregado',
            'Errores',
        ];
        let headerRow = general.addRow(columnas);
        headerRow.eachCell((cell, number) => {
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'D3D3D3' },
                bgColor: { argb: 'FF0000FF' },
            };
            cell.font = {
                size: 11,
                bold: true,
            };
        });
        workbook.xlsx.writeBuffer().then((buffer) => {
            saveAs(
                new Blob([buffer], { type: 'application/octet-stream' }),
                'Plantilla Clientes' + '.xlsx'
            );
        });

    }

    importExcel($event) {

        this.lstClientes = [];
        let file = ($event.target as HTMLInputElement).files[0];
        if (file === undefined) {
            this.tituloFile = 'Seleccione un archivo';
            this._snackBar.open(
                'Favor de seleccionar un archivo válido',
                'Ok',
                { duration: 10000 }
            );

        } else {
            this.tituloFile = file.name;
            if (
                file.name.toLowerCase().indexOf('.xlsx') > 0 ||
                file.name.toLowerCase().indexOf('.xls') > 0
            ) {
                this.xlsxToJSON(file);
            } else {
                this._snackBar.open(
                    'Favor de seleccionar un archivo válido',
                    'Ok',
                    { duration: 10000 }
                );

            }
        }
    }

    xlsxToJSON(event) {

        let fileReader = new FileReader();
        fileReader.readAsArrayBuffer(event);
        fileReader.onload = async (e) => {
            this.arrayBuffer = fileReader.result;
            let data = new Uint8Array(this.arrayBuffer);
            let arr = new Array();
            for (let i = 0; i != data.length; ++i)
                arr[i] = String.fromCharCode(data[i]);
            let bstr = arr.join('');
            let workbook = XLSX.read(bstr, { type: 'binary' });
            let first_sheet_name = workbook.SheetNames[0];
            let worksheet = workbook.Sheets[first_sheet_name];
            let arraylist = XLSX.utils.sheet_to_json(worksheet, { raw: true });
            this.lstClientes = arraylist;
            let validar;
            let cadena;
            let contadorErrores = 0;
            this.lstClientes.forEach((x) => {
                x.NombreRazonSocial = x.NombreRazonSocial.toUpperCase();
                x.RFC = x.RFC.toUpperCase();
                x.Calle = x.Calle.toUpperCase();
                cadena = x.RFC;
                validar = this.rfcValido(cadena, true);
                if (validar === false) {
                    contadorErrores++;
                }
            });
            if (contadorErrores > 0) {
                this.lstClientes.length = 0;
                this._snackBar.open(
                    'Algunos RFC son invalidos, favor de verificar',
                    'Ok',
                    { duration: 10000 }
                );

            } else {
                this._snackBar.open('Carga de datos completa', 'Ok', {
                    duration: 10000,
                });

            }
        };
    }

    rfcValido(rfc, aceptarGenerico = true) {
        const re =
            /^([A-ZÑ&]{3,4}) ?(?:- ?)?(\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])) ?(?:- ?)?([A-Z\d]{2})([A\d])$/;
        let validado = rfc.match(re);

        if (!validado)
            return false;

        // Separar el dígito verificador del resto del RFC
        const digitoVerificador = validado.pop(),
            rfcSinDigito = validado.slice(1).join(''),
            len = rfcSinDigito.length,
            // Obtener el digito esperado
            diccionario = '0123456789ABCDEFGHIJKLMN&OPQRSTUVWXYZ Ñ',
            indice = len + 1;
        let suma, digitoEsperado;

        if (len == 12) suma = 0;
        else suma = 481; // Ajuste para persona moral

        for (let i = 0; i < len; i++)
            suma += diccionario.indexOf(rfcSinDigito.charAt(i)) * (indice - i);
        digitoEsperado = 11 - (suma % 11);
        if (digitoEsperado == 11) digitoEsperado = 0;
        else if (digitoEsperado == 10) digitoEsperado = 'A';

        // El dígito verificador coincide con el esperado?
        // o es un RFC Genérico (ventas a público general)?
        if (
            digitoVerificador != digitoEsperado &&
            (!aceptarGenerico ||
                rfcSinDigito + digitoVerificador != 'XAXX010101000')
        )
            return false;
        else if (
            !aceptarGenerico &&
            rfcSinDigito + digitoVerificador == 'XEXX010101000'
        )
            return false;
        return rfcSinDigito + digitoVerificador;
    }

    procesarArchivo() {
        if (this.lstClientes.length === 0)
            return this._snackBar.open('Favor de cargar un archivo', 'Ok', {
                duration: 10000,
            });
        let xmlCliente = `<propiedades>`;
        this.lstClientes.forEach((e) => {
            xmlCliente += `<propiedad><NombreRazonSocial>${e.NombreRazonSocial}</NombreRazonSocial><RFC>${e.RFC}</RFC><Email>${e.Email}</Email><Calle>${e.Calle}</Calle><NumExterior>${e.NumExterior}</NumExterior><NumInterior>${e.NumInterior}</NumInterior><Colonia>${e.Colonia}</Colonia><CP>${e.CP}</CP><Ciudad>${e.Ciudad}</Ciudad><Municipio>${e.Municipio}</Municipio><Estado>${e.Estado}</Estado><Pais>${e.Pais}</Pais><CfdiUse>${e.CfdiUse}</CfdiUse><NumRegIdTrib>${e.NumRegIdTrib}</NumRegIdTrib><TaxResidence>${e.TaxResidence}</TaxResidence><Agregado>${e.Agregado}</Agregado><Errores>${e.Errores}</Errores></propiedad>`;
        });
        xmlCliente += `</propiedades>`;
        const dialogRef = this.dialog.open(ConfirmDialogComponent, {
            width: '350px',
            data: '¿Desea registrar estos clientes?',
        });
        dialogRef.afterClosed().subscribe((result) => {
            if (result) {
                this.store.dispatch(MostrarSpinner());
                let body = {
                    idRol: 2,
                    idOperacion: this.idOperacion,
                    xmlCliente: xmlCliente,
                };
                //console.log(body);
                this.srvcoal
                    .postService('catalogo/PostINSClienteTemplate', body)
                    .subscribe(
                        (res: any) => {
                            if (res.err) {
                                this.store.dispatch(
                                    MostrarExcepcion({
                                        pila: res.error,
                                        tipoExcepcion: 4,
                                    })
                                );
                            } else if (res.excepcion) {
                                this.store.dispatch(
                                    MostrarExcepcion({
                                        pila: res.excepcion,
                                        tipoExcepcion: 3,
                                    })
                                );
                            } else {
                                this._snackBar.open(
                                    res.recordsets[0][0].mensaje,
                                    'ok',
                                    { duration: 3000 }
                                );
                                this.GetCliente();
                                this.lstClientes.length = 0;
                                this.cargaMasivaCliente = false;
                            }
                        },
                        (error: any) => {
                            this.store.dispatch(
                                MostrarExcepcion({
                                    pila: error,
                                    tipoExcepcion: 2,
                                })
                            );
                            this.store.dispatch(OcultarSpinner());
                        }
                    );
            } else {
                this._snackBar.open('Proceso cancelado', 'OK', {
                    duration: 3000,
                });
                this.store.dispatch(OcultarSpinner());
                this.lstClientes.length = 0;
            }
        });
    }

    nuevoCliente() {
        this.nueCliente = true;
        this.ocultarGrid = true;
        this.cargaMasivaCliente = false;
        let array = [];
        this.datosEventCliente = array;
    }

    carMasivaCliente() {
        this.contadorCargaMasiva++;
        if (this.contadorCargaMasiva % 2) {
            this.cargaMasivaCliente = true;
            this.nueCliente = false;
            this.ocultarGrid = false;
        } else {
            this.cargaMasivaCliente = false;
        }
    }

    invocarEventoCliente(e): void {
        this.contadorCargaMasiva = 1;
        this.nueCliente = false;
        this.ocultarGrid = false;
        this.GetCliente();
    }
    modificar(e) {
        this.store.dispatch(MostrarSpinner());
        this.nuevoCliente();
        let array = [];
        array.push(e);
        this.datosEventCliente = array;
        console.log("modificar", {
            ...this.datosevent,
            idEmpresa: this.idEmpresa
        })
        this.openDialogNewCliente(
            {
                ...this.datosevent,
                mode: 2,
                idEmpresa: this.idEmpresa
            }
            );
    }
    agregarClienteSimplificado() {
        this.openDialogNewCliente({ mode: 3, idEmpresa: this.idEmpresa});
    }
    agregarCliente(){
        this.openDialogNewCliente(
            {
                mode: 1,
                idEmpresa: this.idEmpresa
            }
            );
    }
    eliminar(e) {
        this.EliminaCliente(this.datosevent);
    }

    EliminaCliente(e) {
        const dialogRef = this.dialog.open(ConfirmDialogComponent, {
            width: '350px',
            data: '¿Desea eliminar este registro?',
        });
        dialogRef.afterClosed().subscribe((result) => {
            if (result) {
                this.store.dispatch(MostrarSpinner());

                this.srvcoal
                    .deleteService(`cli-clientes/${e.id}`)
                    .subscribe(
                        (res: any) => {
                            if (res.err) {
                                this.store.dispatch(
                                    MostrarExcepcion({
                                        pila: res.error,
                                        tipoExcepcion: 4,
                                    })
                                );
                            } else if (res.excepcion) {
                                this.store.dispatch(
                                    MostrarExcepcion({
                                        pila: res.excepcion,
                                        tipoExcepcion: 3,
                                    })
                                );
                            } else {
                                this._snackBar.open(
                                    'Eliminado: ' + res.data.attributes.rfc,
                                    'ok',
                                    { duration: 3000 }
                                );
                                const clienteIndex = this.dataReport.findIndex(cliente => cliente.id === e.id);
                                this.dataReport.splice(clienteIndex, 1); //
                                this.store.dispatch(OcultarSpinner());
                                //this.GetCliente();
                            }
                        },
                        (error: any) => {
                            this.store.dispatch(
                                MostrarExcepcion({
                                    pila: error,
                                    tipoExcepcion: 2,
                                })
                            );
                            this.store.dispatch(OcultarSpinner());

                        }
                    );
            } else {
                this._snackBar.open('Eliminacion cancelada', 'OK', {
                    duration: 3000,
                });
                this.store.dispatch(OcultarSpinner());

            }
        });
    }

    EliminaClientePorOperacion() {
        if (this.dataReport.length === 0)
            return this._snackBar.open('No hay registros que eliminar', 'Ok', {
                duration: 10000,
            });
        const dialogRef = this.dialog.open(ConfirmDialogComponent, {
            width: '350px',
            data: '¿Desea eliminar este registro?',
        });
        dialogRef.afterClosed().subscribe((result) => {
            if (result) {
                this.store.dispatch(MostrarSpinner());

                let body = {
                    idOperacion: this.idOperacion,
                };
                this.srvcoal
                    .postService('catalogo/PostDelClientePorOperacion', body)
                    .subscribe(
                        (res: any) => {
                            if (res.err) {
                                this.store.dispatch(
                                    MostrarExcepcion({
                                        pila: res.error,
                                        tipoExcepcion: 4,
                                    })
                                );
                            } else if (res.excepcion) {
                                this.store.dispatch(
                                    MostrarExcepcion({
                                        pila: res.excepcion,
                                        tipoExcepcion: 3,
                                    })
                                );
                            } else {
                                this._snackBar.open(
                                    res.recordsets[0][0].mensaje,
                                    'ok',
                                    { duration: 3000 }
                                );
                                this.GetCliente();
                                this.cargaMasivaCliente = false;
                            }
                        },
                        (error: any) => {
                            this.store.dispatch(
                                MostrarExcepcion({
                                    pila: error,
                                    tipoExcepcion: 2,
                                })
                            );
                            this.store.dispatch(OcultarSpinner());

                        }
                    );
            } else {
                this._snackBar.open('Eliminacion cancelada', 'OK', {
                    duration: 3000,
                });
                this.store.dispatch(OcultarSpinner());

            }
        });
    }

    GetCliente() {
        this.store.dispatch(MostrarSpinner());

        this.verGrid = false;
        this.dataReport.length = 0;
        this.lstDataReport.length = 0;

        this.srvcoal
        .getService(
            `ope-empresas?filters[id]=${this.idEmpresa}&populate=cli_clientes.cat_uso_factura,
            cli_clientes.cat_regimen_fiscal,cli_clientes.dir_direccion.dir_asentamiento.dir_codigo_postal
            ,cli_clientes.dir_direccion.dir_estado
            ,cli_clientes.dir_direccion.dir_pai,cli_clientes.dir_direccion.dir_municipio
            &fields[0]=rfc`
        )
            .subscribe(
                (res: any) => {
                    //this.store.dispatch(OcultarSpinner());
                    if (res.err) {
                        // this.store.dispatch(MostrarExcepcion({ pila: res.error, tipoExcepcion: 4 }))
                        console.log('erro *************** 1');
                    }  else {
                        //
                        //this.dataReportSubject.next(res.data);
                        this.dataReport = res.data[0].attributes.cli_clientes.data;
                        console.log('data report', res.data);
                        this.ObjectGrid();
                    }
                },
                (error: any) => {
                    console.log('erro *************** 3', error);
                    // this.store.dispatch(OcultarSpinner());
                }
            );
    }

    ObjectGrid() {
        let that = this;
        this.nombreReporte = 'Clientes';
        this.objetoGridConfiguration = {
            GridOptions: {
                paginacion: 20,
                pageSize: ['40', '60', '80', '100'],
            },
            ExportExcel: { enabled: false, fileName: 'Historico' },
            ColumnHiding: { hide: true },
            Checkbox: { checkboxmode: 'single' },
            Editing: { allowupdate: true, mode: 'cell' },
            Columnchooser: { columnchooser: true },
            SearchPanel: {
                visible: true,
                width: 200,
                placeholder: 'Buscar...',
                filterRow: true,
            },
            Scroll: { mode: 'infinite' },
            Color: null,
            Detail: { detail: true },
            ToolbarDetail: null,
            ToolBox: [
                {
                    location: 'after',
                    widget: 'dxButton',
                    locateInMenu: 'auto',
                    options: {
                        width: 60,
                        onClick: this.modificar.bind(this),
                        icon: '../../../assets/icons/ver.png',
                    },
                    visible: true,
                    name: 'simple',
                },
                {
                    location: 'after',
                    widget: 'dxButton',
                    locateInMenu: 'auto',
                    options: {
                        width: 60,
                        icon: '../../../assets/icons/borrar.png',
                        onClick: this.eliminar.bind(this),
                    },
                    visible: true,
                    name: 'simple',
                },
            ],
            Columns: [],
            Data: [],
            Columns1: [1],
            Data1: [],
            datosMessage(evento) {
                that.objetosSelected = evento.data;
            },
        };
        this.DataColumnsGrid();
    }

    DataColumnsGrid() {
        if (
            !this.lstDataReport.find(
                (x) => x.idTipoReporte === this.idTipoReporteSel
            )
        ) {
            let columnsMulti = [];
            columnsMulti.push({
                caption: 'Nombre/Razón Social',
                dataField: 'attributes.nombre',
                allowEditing: false,
                fixed: true,
            });
            columnsMulti.push({
                caption: 'RFC',
                dataField: 'attributes.rfc',
                allowEditing: false,
            });
            columnsMulti.push({
                caption: 'Email',
                dataField: 'attributes.email',
                allowEditing: false,
            });
            columnsMulti.push({
                caption: 'Código Postal',
                dataField:
                    'attributes.dir_direccion.data.attributes.codigoPostal',
                allowEditing: false,
            });
            setTimeout(
                () =>
                    this.lstDataReport.push({
                        idTipoReporte: this.idTipoReporteSel,
                        columnas: columnsMulti,
                        dataReport: this.dataReport,
                        identificadorGrid: 0,
                    }),
                500
            );
            setTimeout(() => this.FillGrid(), 800);
        } else {
            this.FillGrid();
        }
    }

    FillGrid() {
        this.objetoGridConfiguration.Columns = this.lstDataReport.find(
            (x) =>
                x.idTipoReporte === this.idTipoReporteSel &&
                x.identificadorGrid === 0
        ).columnas;
        this.objetoGridConfiguration.Data = this.lstDataReport.find(
            (x) =>
                x.idTipoReporte === this.idTipoReporteSel &&
                x.identificadorGrid === 0
        ).dataReport;
        this.verGrid = true;
        this.store.dispatch(OcultarSpinner());
    }
    openDialogNewCliente(data): void {
        console.log("dialog",data)
        const dialogRef = this.dialog.open(DialogNuevoClienteComponent, {
            width: '800px',
            data: data,
            disableClose: true,
        });
        dialogRef.afterClosed().subscribe((result) => {
            if (result.success == 1) {
                const clienteExistente = this.dataReport.find(
                    (cliente) => cliente.id === result.nuevoCliente.id
                );
                if (clienteExistente) {
                    Object.assign(clienteExistente, result.nuevoCliente);
                } else {
                    this.dataReport.push(result.nuevoCliente);
                }
                this.dataReportSubject.next(this.dataReport);
            }
        });
    }
    datosMessage($event) {
        try {
            console.log('soy', $event.data[0]);
            this.datosevent = $event.data[0];
        } catch (error) {
            // this.Excepciones(error, 1);
        }
    }
    Excepciones(pila, tipoExcepcion: number) {
        try {
            const dialogRef = this.dialog.open(ExcepcionesComponent, {
                width: '60%',
                data: {
                    idTipoExcepcion: tipoExcepcion,
                    idUsuario: 1,
                    idOperacion: this.idOperacion,
                    idAplicacion: 1,
                    moduloExcepcion: 'sel-caja-historial.component',
                    mensajeExcepcion: '',
                    stack: pila,
                },
            });
            dialogRef.afterClosed().subscribe((result: any) => {});
        } catch (error) {
            // console.error(error);
        }
    }
}
